import { ARUniversityEntryRequest, ARUniversityEntryRequestFilter } from "../types/requests";
import { ReferenceDataDomain } from "@duosoftbg/nacid-components";
import { SecondaryRecognitionSearchFilter } from "../types/secondaryRecognition";

export const initialARUniversityEntryRequest: ARUniversityEntryRequest = {
  applicant: "",
  applicantEan: "",
  citizenship: { id: "", name: "" },
  university: "",
  universityCountry: { id: "", name: "" },
  educationLevel: "",
  diplomaSpeciality: "",
  diplomaNumber: "",
  diplomaDate: "",
  protocolNumber: "",
  protocolDate: "",
  recognizingUniversity: { universityIdentifier: "", universityName: "" },
  recognizedEducationLevel: { id: "", name: "", domain: ReferenceDataDomain.EDUCATION_LEVEL },
  recognizedSpeciality: "",
  recognizedProfGroup: { id: "", name: "" },
  recognitionStatus: { id: "", name: "", domain: ReferenceDataDomain.ACADEMIC_RECOGNITION_UNI_STATUS },
  relatedRecognitionId: "",
  notes: "",
};

export const initialARUniversityEntryRequestFilter: ARUniversityEntryRequestFilter = {
  applicant: "",
  university: "",
  recognizingUniversity: "",
  recognitionStatusId: "",
  createdUser: "",
  requestStatusId: "",

  order: "desc",
  orderBy: "createdDate",
  page: 0,
  pageSize: 10,
};

export const secondaryRecognitionSearchFilterInitialValues: SecondaryRecognitionSearchFilter = {
  accessCode: "",
};
